import './App.scss';
import Home from './pages/Home';
import {Routes, Route} from 'react-router-dom';                                                                                                                                                                                                                                                                                                                                                                                             
import Services from './pages/Services';
import Contactus from './pages/Contact/Contactus';
import Impressum from './pages/Impressum/Impressum';
import Karriere from './pages/Karriere/Karriere';
import Datenschutz from './pages/Datenschutz/Datenschutz';
import DatenschutzSocialMedia from './pages/DatenschutzSocialMedia/DatenschutzSocialMedia';
import LanguageGuard from './components/LanguageGuard/LanguageGuard';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import OpeningHoursPopup from './components/OpeningHoursPopup/OpeningHoursPopup';
import AosInit from './components/AosInit/AosInit';

function App() {
  return (
    <>
      <LanguageGuard />
      <ScrollToTop />
      <AosInit />
      <OpeningHoursPopup />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/leistungen" element={<Services />} />
        <Route path="/karriere" element={<Karriere />} />
        <Route path="/kontakt" element={<Contactus />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/datenschutz-social-media" element={<DatenschutzSocialMedia />} />
      </Routes>
    </>
  );
}

export default App;
